import { FEATURE_SELECTORS_MAP } from 'guards/FeatureGuard.constants';
import { FeatureType } from 'guards/FeatureGuard.types';
import { useSelector } from 'react-redux';

export const useFeatureSelector = (type: FeatureType) => {
  const feature = useSelector(FEATURE_SELECTORS_MAP[type]);
  return feature;
};
